import React from 'react';

export default function Protections() {
  const styles = {
    heading: {
      color: 'white',
      fontSize: '2.5em',
      marginBottom: '30px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
    },
    protectionLayout: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '40px',
      maxWidth: '100%',
      margin: '0 auto',
      padding: '0 20px'
    },
    protectionIcon: {
      fontSize: '6em',
      marginBottom: '20px',
      display: 'block',
      textAlign: 'center',
      flexShrink: 0,
      width: '200px'
    },
    protectionContent: {
      flex: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '10px',
      padding: '25px',
      border: '1px solid rgba(78, 205, 196, 0.3)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      maxWidth: 'calc(100% - 240px)'
    },
    protectionTitle: {
      color: '#4ecdc4',
      fontSize: '1.6em',
      fontWeight: 'bold',
      marginBottom: '15px'
    },
    protectionDescription: {
      color: 'white',
      fontSize: '1em',
      lineHeight: '1.5',
      marginBottom: '20px'
    },
    protectionLevel: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid rgba(78, 205, 196, 0.3)',
      marginBottom: '15px'
    },
    levelBadge: {
      backgroundColor: '#4ecdc4',
      color: 'white',
      padding: '6px 12px',
      borderRadius: '15px',
      fontSize: '0.9em',
      fontWeight: 'bold',
      display: 'inline-block',
      marginBottom: '8px'
    },
    checklistSection: {
      backgroundColor: 'rgba(78, 205, 196, 0.1)',
      padding: '30px',
      borderRadius: '15px',
      margin: '30px auto',
      maxWidth: '1000px',
      border: '2px solid rgba(78, 205, 196, 0.3)'
    },
    checklistCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      padding: '20px',
      borderRadius: '10px',
      margin: '15px 0',
      border: '1px solid rgba(78, 205, 196, 0.2)',
      transition: 'all 0.3s ease'
    },
    checklistTitle: {
      color: '#4ecdc4',
      fontSize: '1.3em',
      fontWeight: 'bold',
      marginBottom: '10px'
    },
    checklistDescription: {
      color: 'white',
      fontSize: '1em',
      lineHeight: '1.4',
      marginBottom: '15px'
    },
    checklistItems: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    checklistItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      color: 'white',
      fontSize: '0.9em'
    },
    checkIcon: {
      color: '#4ecdc4',
      fontSize: '1.2em'
    }
  };

  const protectionsData = [
    {
      title: 'Systèmes de détection des intrusions (IDS)',
      description:
        "Monitoring en temps réel le trafic réseau et les activités des systèmes à la recherche de comportements anormaux ou de signes d'intrusion.",
      icon: '🔍',
      level: 'Détection',
      levelSource: 'NIST Cybersecurity Framework',
      levelUrl: 'https://www.nist.gov/cyberframework',
      examples: [
        'Surveillance réseau',
        'Analyse comportementale',
        'Alertes temps réel'
      ],
      stats: {
        effectiveness: '85%',
        effectivenessLabel: 'de détection des menaces connues',
        effectivenessSource: 'Gartner Research',
        effectivenessUrl: 'https://www.gartner.com/'
      }
    },
    {
      title: 'Systèmes de prévention des intrusions (IPS)',
      description:
        'Les IPS vont au-delà des IDS en bloquant activement les attaques plutôt que de simplement les signaler.',
      icon: '🛡️',
      level: 'Prévention',
      levelSource: 'NIST Cybersecurity Framework',
      levelUrl: 'https://www.nist.gov/cyberframework',
      examples: ['Blocage automatique', 'Filtrage avancé', 'Réponse immédiate'],
      stats: {
        effectiveness: '92%',
        effectivenessLabel: 'de blocage des attaques',
        effectivenessSource: 'Cisco Security Report',
        effectivenessUrl:
          'https://www.cisco.com/c/en/us/products/security/annual-security-report.html'
      }
    },
    {
      title: 'Antivirus',
      description:
        'Logiciels de détection et suppression des logiciels malveillants.',
      icon: '🦠',
      level: 'Protection',
      levelSource: 'AV-TEST Institute',
      levelUrl: 'https://www.av-test.org/',
      examples: ['Scan en temps réel', 'Base de signatures', 'Quarantaine'],
      stats: {
        effectiveness: '99.7%',
        effectivenessLabel: 'de détection des malwares connus',
        effectivenessSource: 'AV-TEST 2024',
        effectivenessUrl: 'https://www.av-test.org/'
      }
    },
    {
      title: 'Firewall',
      description:
        'Comme une barrière entre plusieurs réseaux. Filtrage, surveillance et contrôle du trafic.',
      icon: '🔥',
      level: 'Filtrage',
      levelSource: 'RFC 2979',
      levelUrl: 'https://tools.ietf.org/html/rfc2979',
      examples: [
        'Filtrage de paquets',
        "Contrôle d'accès",
        'Surveillance du trafic'
      ],
      stats: {
        effectiveness: '95%',
        effectivenessLabel: 'de blocage du trafic malveillant',
        effectivenessSource: 'Fortinet Threat Report',
        effectivenessUrl: 'https://www.fortinet.com/blog/threat-research'
      }
    },
    {
      title: 'Chiffrement',
      description:
        "Protection des données par chiffrement pour assurer la confidentialité et l'intégrité.",
      icon: '🔐',
      level: 'Confidentialité',
      levelSource: 'NIST FIPS 140-2',
      levelUrl: 'https://csrc.nist.gov/publications/detail/fips/140/2/final',
      examples: [
        'Chiffrement des données',
        'Clés de chiffrement',
        'Certificats SSL/TLS'
      ],
      stats: {
        effectiveness: '99.9%',
        effectivenessLabel: 'de protection des données',
        effectivenessSource: 'NIST Cryptographic Standards',
        effectivenessUrl: 'https://www.nist.gov/cryptography'
      }
    },
    {
      title: 'Authentification multi-facteurs (MFA)',
      description:
        "Système d'authentification utilisant plusieurs méthodes de vérification pour sécuriser l'accès.",
      icon: '🔑',
      level: 'Authentification',
      levelSource: 'NIST SP 800-63B',
      levelUrl: 'https://pages.nist.gov/800-63-3/',
      examples: ['SMS', 'Authentificateur', 'Biométrie'],
      stats: {
        effectiveness: '99.9%',
        effectivenessLabel: 'de réduction des compromissions',
        effectivenessSource: 'Microsoft Security Report',
        effectivenessUrl: 'https://www.microsoft.com/security/security-insider'
      }
    }
  ];

  const checklistData = [
    {
      title: 'Checklist de sécurité de base',
      description: 'Les mesures essentielles à mettre en place',
      items: [
        'Mettre à jour régulièrement les systèmes',
        'Utiliser des mots de passe forts',
        "Activer l'authentification multi-facteurs",
        'Sauvegarder régulièrement les données',
        'Former les utilisateurs aux bonnes pratiques'
      ]
    },
    {
      title: 'Checklist de sécurité avancée',
      description: 'Mesures supplémentaires pour une sécurité renforcée',
      items: [
        "Implémenter un système de détection d'intrusion",
        'Configurer un firewall avancé',
        'Mettre en place un système de monitoring',
        'Effectuer des tests de pénétration',
        'Développer un plan de réponse aux incidents'
      ]
    },
    {
      title: 'Checklist de conformité',
      description: 'Mesures pour respecter les réglementations',
      items: [
        'Audit régulier des accès',
        'Documentation des procédures',
        'Formation à la protection des données',
        'Mise en place de politiques de sécurité',
        'Contrôle des accès privilégiés'
      ]
    }
  ];

  return (
    <section>
      <section data-background-color="CadetBlue" data-auto-animate>
        <h1 style={styles.heading}>
          <span role="img" aria-label="Shield">
            🛡️
          </span>{' '}
          Mécanismes de protection
        </h1>
      </section>

      {protectionsData.map((protection, idx) => (
        <section key={idx} data-auto-animate>
          <div style={styles.protectionLayout}>
            <div style={styles.protectionIcon}>
              <span role="img" aria-label="Icon">
                {protection.icon}
              </span>
            </div>
            <div style={styles.protectionContent}>
              <h2 style={styles.protectionTitle}>{protection.title}</h2>
              <p style={styles.protectionDescription}>
                {protection.description}
              </p>

              <div style={styles.protectionLevel}>
                <div style={styles.levelBadge}>Niveau: {protection.level}</div>
                <div
                  style={{
                    color: '#4ecdc4',
                    fontSize: '0.8em',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    display: 'block'
                  }}
                  onClick={() => window.open(protection.levelUrl, '_blank')}
                  title="Cliquer pour voir la source">
                  {protection.levelSource}
                </div>
              </div>

              {protection.stats && (
                <div
                  style={{
                    backgroundColor: 'rgba(78, 205, 196, 0.1)',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid rgba(78, 205, 196, 0.3)',
                    marginBottom: '15px'
                  }}>
                  <div
                    style={{
                      color: '#ff6b6b',
                      fontSize: '1.4em',
                      fontWeight: 'bold',
                      marginBottom: '3px'
                    }}>
                    {protection.stats.effectiveness}
                  </div>
                  <div
                    style={{
                      color: 'white',
                      fontSize: '0.9em',
                      marginBottom: '3px'
                    }}>
                    {protection.stats.effectivenessLabel}
                  </div>
                  <div
                    style={{
                      color: '#4ecdc4',
                      fontSize: '0.8em',
                      textDecoration: 'underline',
                      cursor: 'pointer'
                    }}
                    onClick={() =>
                      window.open(protection.stats.effectivenessUrl, '_blank')
                    }
                    title="Cliquer pour voir la source">
                    {protection.stats.effectivenessSource}
                  </div>
                </div>
              )}

              <div
                style={{
                  backgroundColor: 'rgba(78, 205, 196, 0.1)',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid rgba(78, 205, 196, 0.3)'
                }}>
                <div
                  style={{
                    color: '#4ecdc4',
                    fontSize: '0.9em',
                    fontWeight: 'bold',
                    marginBottom: '8px'
                  }}>
                  Exemples d'implémentation :
                </div>
                <ul
                  style={{
                    color: 'white',
                    fontSize: '0.9em',
                    margin: 0,
                    paddingLeft: '20px'
                  }}>
                  {protection.examples.map((example, exampleIdx) => (
                    <li key={exampleIdx}>{example}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      ))}

      <section>
        <div style={styles.checklistSection}>
          <h2 style={styles.checklistTitle}>
            <span role="img" aria-label="Checklist">
              ✅
            </span>{' '}
            Checklists de sécurité
          </h2>
          <p
            style={{
              color: 'white',
              textAlign: 'center',
              marginBottom: '30px'
            }}>
            Les mesures essentielles à mettre en place pour sécuriser votre
            infrastructure
          </p>

          <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {checklistData.map((checklist, idx) => (
              <div key={idx} style={styles.checklistCard}>
                <div style={styles.checklistTitle}>{checklist.title}</div>
                <div style={styles.checklistDescription}>
                  {checklist.description}
                </div>
                <div style={styles.checklistItems}>
                  {checklist.items.map((item, itemIdx) => (
                    <div key={itemIdx} style={styles.checklistItem}>
                      <span style={styles.checkIcon}>✓</span>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
}
